<template>
  <dd-card data-dusk="policy-groups">
    <dd-form-grid>
      <dd-form-grid-item>
        <div class="flex-row gap-lg w-100">
          <div data-dusk="branch">
            <dd-radio-group
                data-dusk="branch_id"
                name="branch_id"
                :value="branch_id"
                rules="required"
                @click="onBrancheClick"
                title="Hoofdgroep"
            >

              <dd-radio
                  v-for="(branch,idx) in orderedBranches"
                  :key="idx"
                  :value="branch.id" >
                {{ branch.name }}
              </dd-radio>
            </dd-radio-group>
          </div>
          <div data-dusk="view-group">
            <dd-radio-group
                v-if="viewGroupsAlphabetically.length"
                data-dusk="view_group_id"
                name="view_group_id"
                :value="view_group_id"
                rules="required"
                @click="onViewGroupSelect"
                title="Soort polis"
            >
              <dd-radio v-for="[id, name] in viewGroupsAlphabetically" :key="id" :value="id">{{ name }}</dd-radio>
            </dd-radio-group>
          </div>
        </div>
      </dd-form-grid-item>
    </dd-form-grid>
  </dd-card>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from "vuex";
import _ from "lodash";

export default {
  name: "PolicyType",
  created() {
    this.getViewGroups();
  },
  watch: {
    activeBranchId() {
      this.getViewGroups();
    },
  },
  methods: {
    ...mapMutations("$_generic_insurance", {
      setActiveBranchId: "SET_ACTIVE_BRANCH_ID",
      setViewGroupId: "SET_VIEW_GROUP_ID",
      clearGroups: "CLEAR_GROUPS",
      setFormViews: 'SET_FORM_VIEWS'
    }),
    ...mapActions("$_generic_insurance", {
      getViews: "getViews",
      getViewGroupModel: "getViewGroupModel",
    }),
    ...mapActions("$_generic_insurance", {
      getViewGroups: "getViewGroups",
      getViewOptions: "getViewOptions",
    }),
    onBrancheClick(id) {
      this.setActiveBranchId(id);
      this.setViewGroupId(undefined);
    },
    loadNewViewGroup(id) {
      this.clearGroups()
      this.setFormViews([]);
      this.setViewGroupId(id);
      this.getViews();
      this.getViewOptions();
    },
    onViewGroupSelect(id) {
      // Confirm clear any previous loaded groups and values
      if (this.view_group_id) {
        this.notificationsManager.confirm('Oude dekkingsgegevens zullen verwijderd worden.').then(() => {
          this.loadNewViewGroup(id);
        })
      }
      // Else no confirmation is needed
      else {
        this.loadNewViewGroup(id);
      }
    },
  },
  computed: {
    ...mapGetters("$_generic_insurance", {
      viewGroupsAlphabetically: "viewGroupsAlphabetically",
      branches: "branches",
      activeBranchId: "activeBranchId",
    }),
    ...mapState("$_generic_insurance", {
      customerId: "customerId",
    }),
    ...mapGetters("$_generic_insurance", {
      packageId: "packageId",
    }),
    ...mapState("$_generic_insurance", {
      view_group_id: (state) => state.form.view_group_id,
      branch_id: (state) => state.form.branch_id,
    }),
    orderedBranches: function () {
      return _.orderBy(this.branches, 'name')
    },
  },
}
</script>
